import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from '@heroicons/react/24/solid';

const Testimonials = () => {
  const reviews = [
    {
      text: "Asela has made things very easy for my team, we have good in efficiency and speed.",
      name: "Alice Shimmer",
      role: "Product manager",
      category: "SMALL BUSINESS OWNER",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200",
      bgColor: "bg-green-100"
    },
    {
      text: "Good choice! The hairstyles are of good quality. It perfectly matches my personality and feels still nice and detailed.",
      name: "Robert Brown",
      role: "Client",
      category: "INDIVIDUAL CONSUMER",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200",
      bgColor: "bg-blue-100"
    },
    {
      text: "From the very beginning, we appreciated their commitment to understanding our needs. Highly recommended for bridal parties!",
      name: "Elena Rodriguez",
      role: "Bride",
      category: "PREMIUM CUSTOMER",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200",
      bgColor: "bg-purple-100"
    }
  ];

  return (
    <div className="bg-white px-4 py-12 sm:py-20 md:py-24 lg:py-32 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4">
            What Our Clients Are Saying
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto">
            Join thousands of satisfied clients who've experienced our exceptional salon services
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reviews.map((review, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              viewport={{ once: true, margin: '-50px' }}
              className="flex flex-col"
            >
              {/* Quote Card */}
              <div className={`${review.bgColor} rounded-2xl p-6 sm:p-8 flex-grow flex flex-col justify-center mb-6 relative`}>
                {/* Quote Icon */}
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400 mb-4 opacity-50" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M3 21c3 0 7-1 7-8V5c0-1.25-4.716-5-7-5S0 3.75 0 5v10c0 7 4 8 7 8zm14 0c3 0 7-1 7-8V5c0-1.25-4.716-5-7-5s-7 3.75-7 5v10c0 7 4 8 7 8z"></path>
                </svg>
                
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed font-medium">
                  {review.text}
                </p>
              </div>

              {/* Profile Section */}
              <div className="flex items-center gap-3 sm:gap-4 mb-3">
                <img 
                  src={review.image} 
                  alt={review.name} 
                  className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-gray-200"
                />
                <div>
                  <h4 className="text-sm sm:text-base font-semibold text-gray-900">{review.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{review.role}</p>
                </div>
              </div>

              {/* Category Badge */}
              <div>
                <span className="text-xs font-bold tracking-widest text-gray-500 uppercase">
                  {review.category}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Testimonials;
